import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as NoDataSVG } from "../assets/img/bug.svg";

const BugComponent = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", my: 2, p: 3 }}>
      <div>
        <NoDataSVG />
        <br />
        <Typography variant="h6" my={0.5}>
          {"Something Went Wrong, Please Try Again After Some Time."}
        </Typography>
      </div>
    </Box>
  );
};
export default BugComponent;
